import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dot from './Dot'
import UserRankingWire from '../ranking/UserRankingWire'
import ZoomSwitch from '../fixedComponents/ZoomSwitch'

export class Zoom extends Component {

  render() {
    const { server, client } = this.props
    return(
      <div className='zoom-background'>
        <Dot id={server.rootId} number={String(client.rootNumber)}
          parent={String(client.rootNumber)} root={true} page={0}/>
        <UserRankingWire />
        <ZoomSwitch />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Zoom)



// WEBPACK FOOTER //
// ./src/components/dots/Zoom.js